const SearchParamKeys = {
  integrationTabId: 'integrationTabId',
  futureState: 'futureState',
  view: 'view',
  tab: 'tab',
  expand: 'expand',
};
export default SearchParamKeys;
